import { apiClient, MESSAGES } from '../../../shared/api';

export const createMessage = async ({ messageContent, taskId }) => {
  const requestBody = {
    message: {
      content: messageContent,
    },
    task_id: taskId,
  };

  const response = await apiClient.post(MESSAGES, requestBody);

  return response.data;
};
